
import { Button, IconButton } from "@material-tailwind/react";
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from "react-icons/fa";

interface PaginationProps {
  totalPages: number;
  currentPage: number;
  setCurrentPage: (value:number)=>void
}

export function DefaultPagination({
  totalPages,
  currentPage,
  setCurrentPage,
}: PaginationProps) {


  const getItemProps = (index: number) =>
    ({
      variant: currentPage === index ? "filled" : "text",
      color: "gray" as const,
      onClick: () => setCurrentPage(index),
    } as const);

  const next = () => {
    if (currentPage === totalPages) return;
  };

  const prev = () => {
    if (currentPage === 1) return;
  };

  return (
    <div className="flex items-center gap-4 justify-center mt-8">
      <Button placeholder={undefined} 
        variant="text"
        className="flex items-center gap-2"
        onClick={prev}
        disabled={currentPage === 1}
      >
        <FaArrowAltCircleLeft strokeWidth={2} className="h-4 w-4" /> Previous
      </Button>
      <div className="flex items-center gap-2">
        {Array.from({ length: totalPages }, (_, index) => (
          <IconButton placeholder={undefined}  key={index} {...getItemProps(index + 1)}>
            {index + 1}
          </IconButton>
        ))}
      </div>
      <Button placeholder={undefined} 
        variant="text"
        className="flex items-center gap-2"
        onClick={next}
        disabled={currentPage === totalPages}
      >
        Next
        <FaArrowAltCircleRight strokeWidth={2} className="h-4 w-4" />
      </Button>
    </div>
  );
}
